import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Translate } from '../../../language';
import InputSearch from '../../../utils/components/InputSearch/InputSearch';
import { useDispatch } from 'react-redux';
import { searchAction } from '../../../actions/searchActions';
import { useSelector } from 'react-redux';
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';
import { deleteConversation, getConversation } from '../../../actions/messagesActions';
import { useHistory, useLocation } from 'react-router-dom';
import roomImg from '../../../assets/img/rooms.png'
import localStorage from '../../../utils/hooks/useLocalStorage';
import { getConversationFixed, getConversationsFixed, sendMessageFixed } from '../../../actions/slices/chat/thunk';
import moment from 'moment';
import ChatCardMessage from '../../../containers/Chat/Message/ChatCardMessage';
import ChatInput from '../../../containers/Chat/ChatInput';
import socketLogic from '../../../sockets/sockets'
import { appendMessage } from '../../../actions/slices/chat/chatSlice';
export const Chat = () => {
    const dispatch = useDispatch()
    const {
        conversationsList,
        isLoadingConversationsList } = useSelector(state => state.messages)

    const {
        users,
        conversation } = useSelector(state => state.chat)


    const { isLoadingSearchList, searchList } = useSelector(state => state.users)
    const [replyMenssage, setReplyMenssage] = useState(null)
    const history = useHistory()
    const location = useLocation()

    const scroolRef = useRef(null);
    const scroolToBottom = () => {

        if (scroolRef.current) {
            const scrollHeight = scroolRef.current.scrollHeight;
            const height = scroolRef.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            scroolRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
    }


    useEffect(() => {
        dispatch(getConversationsFixed())
    }, []);

    useEffect(() => {

        scroolToBottom()
    }, [conversation]);

    const onMessage = useCallback(async (data) => {
        if (data.from._id === conversation.user?._id) {

            dispatch(appendMessage(data.bodyMessage))

        }
    }, [conversation.user?._id, dispatch])

    useEffect(() => {

        socketLogic.listenAllEvents("private-message", onMessage);

        return () => {
            //  setFiles([])
            socketLogic.removeListener("private-message", onMessage)
        }
    }, [conversation.user, onMessage])
    useEffect(() => {
        if (location.state && location.state.dataUser) {
            dispatch(getConversationFixed(location.state.dataUser))
            history.replace()
        }
        return () => {
        }
    }, [])
    const handleNewUserMessage = async (dataFiles, content, clear) => {
        dispatch(sendMessageFixed({
            replyMenssage,
            addresseeId: conversation.user._id,
            dataFiles,
            content
        },
            clear
        ))

    }
    return (
        <div className="column">
            <div className="content-left-messages scroll-menu">
                <div className="contacts-for-messages">
                    <div className="text-bold">{'Mensajes'}</div>
                    <div className="">
                        <InputSearch
                            placeholder={Translate('searchPalcheholder', 'es')}
                            classNameContent=""
                            searchData={(value) => {
                                dispatch(searchAction(value, "userAndFranchises"))
                            }}
                            isLoading={isLoadingSearchList}
                            renderData={searchList && searchList.userAndFranchises && (

                                <>
                                    {
                                        searchList.userAndFranchises[0].users.map(user => {
                                            let data = user;
                                            if (user.warehouseID) {


                                                data._id = user.warehouseID
                                                data.lastname = null

                                            }
                                            if (user.representativeID) {
                                                if (user.representativeID.state === 2) {

                                                    data._id = user.representativeID._id
                                                }
                                            }
                                            return (
                                                <ImageNameDescription
                                                    key={user._id}
                                                    options={[]}
                                                    onClick={() => {


                                                        // setUserChat(user)
                                                        //setIdUserChat(user.warehouseID ? user.warehouseID : user._id)
                                                    }}
                                                    description={null}
                                                    srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                                    firstName={user.name}
                                                    secondName={user.lastname}
                                                />
                                            )
                                        }

                                        )
                                    }
                                    {
                                        searchList.userAndFranchises[0].franchises.map(franchise =>
                                            <ImageNameDescription
                                                key={franchise._id}
                                                options={[]}
                                                onClick={() => {
                                                    /*  setUserChat({
                                                         name: franchise.socialReason,
                                                         picture: franchise.picture && franchise.picture.url ? franchise.picture.url.small : franchise.picture,
                                                         lastConnection: franchise.lastConnection
 
                                                     }) */
                                                    // setIdUserChat(franchise._id)
                                                }}
                                                description={null}
                                                srcImage={franchise.picture && franchise.picture.url ? franchise.picture.url.small : franchise.picture}
                                                firstName={franchise.socialReason}

                                            />

                                        )
                                    }



                                </>
                            )}

                        />
                    </div>
                    {users.map(({ addresseeData, conversation }, index) => {
                        let room = conversation.secondRoomId || conversation.secondRoomId
                        let src = null
                        let name = null
                        let lastname = null
                        switch (addresseeData.type) {
                            case "user":
                                src = addresseeData?.picture && addresseeData.picture.url ? addresseeData.picture.url.small : addresseeData.picture
                                name = addresseeData.name.split(" ")[0]
                                lastname = addresseeData.lastname.split(" ")[0]
                                break;
                            case "franchise":
                                src = addresseeData?.picture && addresseeData.picture.url ? addresseeData.picture.url.small : addresseeData.picture
                                name = addresseeData.socialReason
                                break;
                            case "representative":

                                src = addresseeData?.userID && addresseeData?.userID.picture && addresseeData?.userID.picture && addresseeData.userID.picture.url ? addresseeData.userID.picture.url.small : addresseeData.userID.picture
                                name = addresseeData.userID.name.split(" ")[0]
                                lastname = addresseeData.userID.lastname.split(" ")[0]
                                break;
                            case "warehouse":
                                name = addresseeData.name
                                src = addresseeData?.profileId && addresseeData?.profileId.picture && addresseeData?.profileId.picture && addresseeData.profileId.picture.url ? addresseeData.profileId.picture.url.small : addresseeData.profileId.picture
                                break;
                            case "chatroom":
                                name = addresseeData.name
                                src = room?.profilePicture ? (room.profilePicture.url ? room.profilePicture.url.small : room.profilePicture) : roomImg
                                break;
                            case "admin":
                                name = addresseeData.name
                                src = addresseeData.picture && addresseeData.picture && addresseeData.picture.files && addresseeData.picture.files.url.origin
                                break;
                        }



                        return <ImageNameDescription
                            key={index}
                            shouldEllipsis
                            optionStyle={{
                                marginLeft: "auto",
                                position: "relative"
                            }}
                            options={[
                                {
                                    text: 'eliminar',
                                    onClick: () => {
                                        dispatch(deleteConversation(conversation._id, index));
                                    }
                                }
                            ]}
                            onClick={(e) => {//firstFranchiseId
                                e.preventDefault(); e.stopPropagation();
                                if (room) {
                                    history.push("/Rooms/Room/" + room._id)
                                } else {

                                    dispatch(getConversationFixed(addresseeData))
                                }

                                //  if (user.data._id !== idUserChat) setAllMessage([])
                                // lastMensaje[user.data._id] && setLastMensaje(prevState => { return { ...prevState, [user.data._id]: { message: lastMensaje[user.data._id].message, read: true } } })
                                // changeStyleimageNameDescription()


                            }}
                            srcImage={src}
                            firstName={name}
                            secondName={lastname}
                            description={(conversation.lastMessage.senderID !== localStorage().getItem("idProfile") ? "" : "» ") + conversation.lastMessage.content}
                            type={''}
                        />

                    })}
                </div>
            </div>
            <div className="container-right-messages">
                <div className="column">
                    <div className="container-rooms-chats">
                        <div className="navbar-room-info">
                            {conversation.user &&
                                <>
                                    <ImageNameDescription
                                        conversationId=''
                                        options={[]}
                                        srcImage={conversation.user.picture && conversation.user.picture.url ? conversation.user.picture.url.small : conversation.user.picture}
                                        firstName={conversation.user.name}
                                        secondName={conversation.user.lastname}
                                        shouldDscriptionEllipsis={false}
                                        description={!conversation.user.connectionStatus ? moment(conversation.user.lastConnection).fromNow() : "Online"}
                                    />
                                </>

                            }

                        </div>
                        <div ref={scroolRef} className={`content-message-conversation scroll-menu `}>

                            {conversation.messages.map((message, index) => {
                                return <ChatCardMessage key={index}
                                    isSelf={

                                        message.senderID === localStorage().getItem('idProfile') ||
                                        message.senderID === localStorage().getItem('idUser')
                                    }
                                    message={message}
                                    idUser={localStorage().getItem('idUser')}
                                    replyMenssage={replyMenssage}
                                    setReplyMenssage={setReplyMenssage}

                                    srcImage={
                                        message.senderUserId ? (message.senderUserId.picture && message.senderUserId.picture.url ? message.senderUserId.picture.url.small : message.senderUserId.picture)
                                            : message.senderFranchiseId ? (message.senderFranchiseId && message.senderFranchiseId.picture && message.senderFranchiseId.picture.url ? message.senderFranchiseId.picture.url.small : message.senderFranchiseId.picture)
                                                : message.senderRepresentativeId ? (message.senderRepresentativeId.userID.picture
                                                    && message.senderRepresentativeId.userID.picture.url ? message.senderRepresentativeId.userID.picture.url.small : message.senderRepresentativeId.userID.picture)
                                                    : message.senderAdminId ?
                                                        (message.senderAdminId.picture.files.url.origin) : message.senderWarehouseId ?

                                                            (message.senderWarehouseId.profileId.picture
                                                                && message.senderWarehouseId.profileId.picture.url ? message.senderWarehouseId.profileId.picture.url.small : message.senderWarehouseId.profileId.picture)
                                                            : ''



                                    } />
                            })}

                        </div>
                        {conversation.user &&

                            <ChatInput
                                replyMenssage={replyMenssage}
                                setReplyMenssage={setReplyMenssage}
                                handleNewUserMessage={handleNewUserMessage} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
